import PropTypes from 'prop-types';
import React from 'react';
import {
  ButtonGroup,
  Button,
} from 'react-bootstrap';
import { bidStates } from '../../../core/api';

class BidToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.save = this.save.bind(this);
  }
  save(e) {
    e.preventDefault();
    const state = e.currentTarget.getAttribute('data-item');
    console.log('saving new state: ', state);
    const payload = {};
    payload.bidder_state = state;
    this.props.editBid(this.props.bid.id, payload);
  }

  getCommandsFromState() {
    try {
      const nobid = <Button onClick={this.save} data-item="NB" bsStyle="info" title="Notify buyer you are not able to provide lodging for this stay."><i className="fa fa-ban fa-lg" /> No Bid</Button>;
      const send = <Button onClick={this.props.displayBidAssignment} title="Assign to a hotel" bsStyle="info"><i className="fa fa-user fa-lg" /> Assign</Button>;
      // const share = <Button onClick={this.share} bsStyle="info" title="Forward bid to someone else."><i className="fa fa-share fa-lg" /> Share Bid</Button>;
      const cancel = <Button onClick={this.save} data-item="CA" title="Cancel bid that already been submitted." bsStyle="info"><i className="fa fa-cancel fa-lg" /> Cancel Bid</Button>;
      const accept = <Button onClick={this.save} data-itme="AC" bsStyle="info"><i className="fa fa-cancel fa-lg" /> Confirm Acceptance</Button>;

      const bidCommands = {
        Sent: {
          Unread: [nobid, send],
          Viewed: [nobid, send],
          Replied: [cancel],
          Nobid: [],
        },
        Pending: {
          Replied: [cancel],
        },
        Interested: {
          Replied: [cancel],
          Cancel: [],
        },
        Decline: {
          Declined: [],
        },
        Accept: {
          Replied: [accept, cancel],
          // TODO: Accepted: ['Approve Contract', 'Decline'],
          Accepted: [],
        },
        Contracted: {
          Contracted: [],
        },
      };
      return bidCommands[
          bidStates[this.props.bid.buyer_state]
        ][
          bidStates[this.props.bid.bidder_state]
        ];
    } catch (e) {
      console.log(e);
      // For bad states not commands are returned
      return [];
    }
  }

  render() {
    const commands = this.getCommandsFromState();
    if (!commands) {
      return null;
    }
    const toolbar = commands.map(command => command);
    return (
      <ButtonGroup>
        {toolbar}
      </ButtonGroup>
    );
  }
}

BidToolbar.propTypes = {
  bid: PropTypes.object.isRequired,
  displayBidAssignment: PropTypes.func.isRequired,
  editBid: PropTypes.func.isRequired,
};

export default BidToolbar;



// WEBPACK FOOTER //
// src/routes/booking/components/BidToolbar.js